/**
 * Model reprezentujący akcję (zdarzenie analityczne) wykonaną na banerze Partnera.
 * Służy do śledzenia skuteczności kampanii reklamowych w aplikacji i wyświetlania statystyk w Dashboardzie.
 */
export class PartnerBannerAction {

  /** Unikalny identyfikator zarejestrowanej akcji / rekordu statystyki. */
  public uuid: string;

  /** Data i czas wystąpienia zdarzenia.
   * Używane do filtrowania wyników po dacie.
   * (Widoczne w UX).
   */
  public created: Date;

  /** Identyfikator użytkownika, który wszedł w interakcję z banerem.
   */
  public userUUID: string;

  /** ID klienta biznesowego, w kontekście którego nastąpiła akcja. */
  public vClientUUID: string;

  /** ID konkretnej placówki weterynaryjnej, w której pacjent wszedł w interakcję z banerem
   * (Widoczne w UX).
   */
  public vetcodeId: number;

  /** Liczba wystąpień danej akcji.
   * (Widoczne w UX).
   */
  public count: number;

  /** Powiązanie z konkretną usługą / klasyfikatorem wizyty (VetReservationClassifierData).
   */
  public vetReservationClassifierDataUUID: string;

  /** UUID Partnera (Reklamodawcy), do którego należy ten baner.
   */
  public partnerVClientUUID: string;

  /** Tagi / reguły targetowania, które spowodowały wyświetlenie tego banera.
   * (Widoczne w UX).
   */
  public ruleTags: string;

  /** Data usunięcia.
   */
  public deleted: Date;

  constructor() {
  }
}
